import PropTypes from 'prop-types'

import { SuggestPreferredLaneLoadboard } from 'preferred-lanes/ui/SuggestPreferredLaneLoadboard'

import { RMISBanner } from '../CarrierManager/RMIS/RMISBanner'
import { BannerWrapper } from './LoadDetails.styles'

function LoadDetailsBanner({ userIsLoggedIn, showOnboardingImprovements }) {
  return (
    <BannerWrapper>
      {!showOnboardingImprovements && <RMISBanner compact />}
      <SuggestPreferredLaneLoadboard />
    </BannerWrapper>
  )
}

LoadDetailsBanner.propTypes = {
  userIsLoggedIn: PropTypes.bool.isRequired,
  showOnboardingImprovements: PropTypes.bool.isRequired,
}

export { LoadDetailsBanner }
